import * as Yup from 'yup'

import { APPLICANT_CHECKLIST_REJECT_REASON_MAX_LENGTH } from '../ApplicantDocumentChecklist.constants'

import { APPLICANT_DOCUMENT_REJECT_FIELD_NAME } from './ApplicantDocumentRejectModal.constants'

export function getApplicantDocumentRejectValidationSchema(t) {
  return Yup.object({
    [APPLICANT_DOCUMENT_REJECT_FIELD_NAME]: Yup.string()
      .trim()
      .required(true)
      .max(
        APPLICANT_CHECKLIST_REJECT_REASON_MAX_LENGTH,
        t('Error.MaxLengthKey', {
          length: APPLICANT_CHECKLIST_REJECT_REASON_MAX_LENGTH,
        })
      ),
  })
}

export function getApplicantDocumentRejectReason(values) {
  return values[APPLICANT_DOCUMENT_REJECT_FIELD_NAME].trim()
}
